import { UrPlayerConfig } from '../types'
import { PreSetupHook } from '../urPlayerManager'

export const convertToSeconds = (time: string): number => {
  const [hours, minutes, seconds] = time.split(':').map(Number)
  return hours * 3600 + minutes * 60 + seconds
}

const startTime: PreSetupHook = (
  _id: string,
  urPlayerConfig: UrPlayerConfig,
) => {
  if (urPlayerConfig.startTime) {
    const startInSeconds = convertToSeconds(urPlayerConfig.startTime)
    return { starttime: startInSeconds }
  }

  return null
}

export default startTime
